import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { TarihInput } from "@/components/TarihInput";
import { toast } from "sonner";
import { Save } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { PageHeader, GlassCard, GradButton, Field } from "@/components/erp";
import { SelectBox } from "@/components/Inputs";
import { useAuth } from "@/context/AuthContext";
import { ONAY_KURAL } from "@/lib/perms";
import api, { errMsg } from "@/lib/api";

const GUNLER = ["Pzt", "Sal", "Çar", "Per", "Cum", "Cmt", "Paz"];

const Takvim = ({ f, set }) => {
  const [yeni, setYeni] = useState("");
  const tog = (i) => set("calisma_gunleri", f.calisma_gunleri.includes(i) ? f.calisma_gunleri.filter((x) => x !== i) : [...f.calisma_gunleri, i].sort());
  return (
    <div className="space-y-3" data-testid="ayar-takvim">
      <div className="font-semibold">Çalışma takvimi <span className="text-xs font-normal text-muted-foreground">(termin hesabında sayılan günler)</span></div>
      <div className="flex flex-wrap gap-2">{GUNLER.map((g, i) => (
        <button type="button" key={g} data-testid={`ayar-gun-${i}`} onClick={() => tog(i)} className={`px-3 py-1.5 rounded-full text-xs border ${f.calisma_gunleri.includes(i) ? "bg-[var(--g1)] border-[var(--g1)] text-white font-semibold" : "border-white/15 text-muted-foreground"}`}>{g}</button>))}</div>
      <div className="flex flex-wrap items-center gap-2">
        <TarihInput data-testid="ayar-tatil-tarih" value={yeni} onChange={(e) => setYeni(e.target.value)} className="max-w-[200px]" placeholder="Tatil günü" />
        <button type="button" data-testid="ayar-tatil-ekle" disabled={!yeni} onClick={() => { set("tatiller", [...new Set([...f.tatiller, yeni])].sort()); setYeni(""); }} className="px-4 h-10 rounded-lg text-sm border border-white/20 hover:bg-white/5 disabled:opacity-40">Tatil ekle</button>
      </div>
      <div className="flex flex-wrap gap-2" data-testid="ayar-tatiller">{f.tatiller.map((t) => (
        <span key={t} className="inline-flex items-center gap-1 text-xs px-2.5 py-1 rounded-full bg-white/5">{new Date(`${t}T00:00:00`).toLocaleDateString("tr-TR")}
          <button type="button" data-testid={`ayar-tatil-sil-${t}`} onClick={() => set("tatiller", f.tatiller.filter((x) => x !== t))}><X className="w-3 h-3" /></button></span>))}
        {!f.tatiller.length && <span className="text-xs text-muted-foreground">Resmi tatil / bayram eklenmedi.</span>}</div>
    </div>
  );
};

export default function SiparisAyarlari() {
  const { loadAyar } = useAuth();
  const [f, setF] = useState(null);
  useEffect(() => { api.get("/ayarlar").then((r) => setF({ b2b_direkt_imalat: !!r.data.b2b_direkt_imalat, varsayilan_onay_kurali: r.data.varsayilan_onay_kurali || "siparis_dahil", termin_gun: r.data.termin_gun ?? 7, calisma_gunleri: r.data.calisma_gunleri?.length ? r.data.calisma_gunleri : [0, 1, 2, 3, 4, 5], tatiller: r.data.tatiller || [] })); }, []);
  const set = (k, v) => setF((s) => ({ ...s, [k]: v }));
  const kaydet = async () => {
    try { await api.put("/ayarlar", { ...f, termin_gun: Number(f.termin_gun) || 0 }); await loadAyar(); toast.success("Sipariş ayarları kaydedildi"); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!f) return null;
  return (
    <div data-testid="siparis-ayarlari-page">
      <PageHeader title="Sipariş Ayarları" desc="Siparişlerin onaydan sevkiyata kadar nasıl ilerleyeceğini belirler." />
      <GlassCard className="p-6 space-y-5 max-w-3xl">
        <div className="font-semibold">Sipariş akıbeti</div>
        <label className="flex items-start gap-3 text-sm"><Switch data-testid="ayar-b2b-imalat" checked={f.b2b_direkt_imalat} onCheckedChange={(v) => set("b2b_direkt_imalat", v)} />
          <span>B2B (bayi portalı) siparişleri risk limiti içindeyse doğrudan imalata verilsin<span className="block text-xs text-muted-foreground">Stokta olan miktar ayrılır, eksik kalan miktar için iş emri otomatik açılır. Kapalıysa eksik miktar üretim planına düşer ve "Üret" ile iş emri açılır.</span></span></label>
        <Field label="Yeni müşterilerde sipariş onay kuralı (cari kartından değiştirilebilir)">
          <SelectBox testid="ayar-siparis-onay-kurali" value={f.varsayilan_onay_kurali} onChange={(v) => set("varsayilan_onay_kurali", v)} options={Object.entries(ONAY_KURAL).map(([value, label]) => ({ value, label }))} />
        </Field>
        <Field label="Varsayılan teslim süresi (iş günü)"><Input data-testid="ayar-siparis-termin" type="number" className="bg-white/5 max-w-[160px]" value={f.termin_gun} onChange={(e) => set("termin_gun", e.target.value)} /></Field>
        <Takvim f={f} set={set} />
        <GradButton data-testid="siparis-ayar-kaydet" onClick={kaydet}><Save className="w-4 h-4" />Kaydet</GradButton>
      </GlassCard>
    </div>
  );
}
